module.exports = __webpack_public_path__ + "static/media/umetniki-2.bc7e543e.png";